import type { AssessmentStatus, CorrectiveActionStatus } from '@/types';
import { courseLink } from '@/lib/course-link';

// Etiquetas/badges del detalle de evaluación. Extraído por ENG-LOC-01.

// F5b — deep-link target + label for the concrete next activity.
export const NEXT_ACTIVITY_LINK: Record<string, { to: (id: number) => string; label: string }> = {
  // El paso siguiente guarda el id del curso, no de la inscripción.
  course: { to: courseLink, label: 'Ir a la capacitación' },
  // I4: deep-link to the specific assigned reading (highlighted) where the
  // colaborador can read + confirm it, instead of the generic documents list
  // where it gets lost among the others.
  document: { to: (id) => `/documents/readings?highlight=${id}`, label: 'Ir al documento' },
};

export const TYPE_BADGES: Record<string, string> = {
  probation: 'bg-blue-100 text-blue-700',
  competency_check: 'bg-amber-100 text-amber-700',
  // Legacy / fallback values
  initial: 'bg-blue-100 text-blue-700',
  periodic: 'bg-purple-100 text-purple-700',
  post_training: 'bg-amber-100 text-amber-700',
};

export const TYPE_LABELS: Record<string, string> = {
  probation: 'Período de Prueba',
  competency_check: 'Verificación de Competencia',
  // Legacy / fallback values
  initial: 'Inicial',
  periodic: 'Periódica',
  post_training: 'Post-capacitación',
};

export const STATUS_BADGES: Record<AssessmentStatus, string> = {
  pending: 'bg-blue-100 text-blue-700',
  in_progress: 'bg-amber-100 text-amber-700',
  completed: 'bg-green-100 text-green-700',
};

export const STATUS_LABELS: Record<AssessmentStatus, string> = {
  pending: 'Pendiente',
  in_progress: 'En Progreso',
  completed: 'Completada',
};

export const CA_STATUS_BADGES: Record<CorrectiveActionStatus, string> = {
  open: 'bg-red-100 text-red-700',
  in_progress: 'bg-amber-100 text-amber-700',
  resolved: 'bg-green-100 text-green-700',
};

export const CA_STATUS_LABELS: Record<CorrectiveActionStatus, string> = {
  open: 'Abierta',
  in_progress: 'En Progreso',
  resolved: 'Completada',
};
